import {div, input, label, button, p} from '@motorcycle/dom';

import most from 'most'

export default (sources)=> {
  const vtree$ = most.just('woo').map(s =>
    div([
      div('.app-container', [
        label('Name:'),
        input('.field', {attrs: {type: 'text'}, props:{value: 'foobar'}}),
        button('.submitbtn','Submit')
      ]),
      p( 'laj laj laj' )
    ])
  )
  return {
    DOM: vtree$
  }
}



/** WEBPACK FOOTER **
 ** ./components/pannes.js
 **/